import * as React from 'react'

export interface ErrorBoundaryProps {
  renderError?: (error: any, reset: () => void) => React.ReactNode
  children?: React.ReactNode
}

export interface ErrorBoundaryState {
  error?: any
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    error: undefined,
  }

  public componentDidCatch(error: any, _info: any) {
    this.setState({ error })
  }

  public render() {
    const { renderError, children } = this.props
    const { error } = this.state
    if (!error) {
      return children
    } else if (renderError) {
      return renderError(error, () => this.setState({ error: undefined }))
    } else {
      return null
    }
  }
}
